import React from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Folder from '@mui/icons-material/Folder';
import PlayCircleOutline from '@mui/icons-material/PlayCircleOutline';

import { SearchResultListItem } from '@/exceed';

import VideoShortcutTag from './videoShortcutTag';

import styles from '../styles/videosAdminSearchResultItem.module.scss';

const VideosAdminSearchResultItem = ({ item, onKebabMenuItemClick, components: { KebabMenu } }) => {
  const { id, type, metadata, breadcrumbs } = item;

  const isTopic = type === 'topic';
  const { orgId, type: videosType } = useParams();
  const rootUrl = `/videos/organizations/${orgId}/${videosType}`;
  const url = isTopic ? `${rootUrl}/topics/${id}` : `${rootUrl}/${id}/compose`;
  const isShortcut = metadata?.is_shortcut;
  const tag = isShortcut ? (<VideoShortcutTag />) : null;
  const icon = isTopic ? <Folder /> : <PlayCircleOutline />;

  const breadcrumbItems = (breadcrumbs || []).map((ancestor) => ({
    id: ancestor.id,
    text: ancestor.name,
    path: `${rootUrl}/topics/${ancestor.id}`,
    key: ancestor.id,
  }));

  return (
    <SearchResultListItem
      item={{
        ...item,
        breadcrumbs: breadcrumbItems,
        url,
        icon,
        iconClassName: styles.icon,
        tag,
      }}
      components={{ KebabMenu }}
      onKebabMenuItemClick={onKebabMenuItemClick}
      className={classnames(isTopic && styles.isTopic)}
    />
  );
};

VideosAdminSearchResultItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number,
    type: PropTypes.oneOf(['topic', 'video']),
    metadata: PropTypes.shape({
      is_shortcut: PropTypes.bool,
    }),
    name: PropTypes.string,
    ancestry: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
      }),
    ),
  }).isRequired,
};

export default React.memo(VideosAdminSearchResultItem);
